var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import Container from "./Container.js";
import Tooltip from "./Tooltip.js";
import StringHelper from "../helper/StringHelper.js";
import "./Button.js";
import "./FileField.js";
class FilePicker extends Container {
  construct(config = {}) {
    const me = this;
    config.items = [
      Object.assign({
        type: "button",
        ref: "fileButton",
        text: "L{FilePicker.file}",
        localeClass: this
      }, config.buttonConfig),
      Object.assign({
        type: "filefield",
        ref: "fileField",
        style: "display: none"
      }, config.fileFieldConfig)
    ].concat(config.items || []);
    super.construct(config);
    me.button.ion({
      click: me.onButtonClick,
      thisObj: me
    });
    me.fileField.ion({
      change: me.onFileFieldChange,
      thisObj: me
    });
    me._thisIsAUsedExpression(me.fileTip);
  }
  get button() {
    return this.widgetMap.fileButton;
  }
  get fileField() {
    return this.widgetMap.fileField;
  }
  /**
   * List of selected files
   * @property {FileList}
   * @readonly
   */
  get files() {
    return this.fileField.files;
  }
  get fileTip() {
    const me = this;
    return me._fileTip || (me._fileTip = new Tooltip({
      cls: "b-file-tip",
      forElement: me.button.element,
      showOnHover: true,
      align: "b-t",
      scrollAction: "realign",
      internalListeners: {
        beforeshow() {
          const tip = this, files = me.files;
          if (files && files.length) {
            tip.html = `${Array.from(files).map((file) => StringHelper.encodeHtml(file.name)).join("<br>")}`;
            return true;
          }
          return false;
        }
      }
    }));
  }
  /**
   * Clears field
   */
  clear() {
    const me = this;
    me.fileField.clear();
    me.updateBadge();
    me.trigger("clear");
  }
  onButtonClick({ event }) {
    const me = this;
    me.fileField.pickFile();
    event.preventDefault();
  }
  onFileFieldChange({ valid }) {
    const me = this;
    me.updateBadge();
    me.triggerFieldChange({ files: me.files, valid });
  }
  updateShowBadge() {
    if (!this.isConfiguring) {
      this.updateBadge();
    }
  }
  updateBadge() {
    this.button.badge = this.showBadge && this.files.length || "";
  }
}
__publicField(FilePicker, "$name", "FilePicker");
__publicField(FilePicker, "type", "filepicker");
__publicField(FilePicker, "configurable", {
  /**
   * The name of the property to set when a single value is to be applied to this FilePicker. Such as when used
   * in a grid WidgetColumn, this is the property to which the column's `field` is applied.
   * @config {String}
   * @default
   * @category Misc
   */
  defaultBindProperty: "value",
  /**
   * Fires after user closes file picker dialog.
   * @event change
   * @param {FileList} files List of picked files
   */
  /**
   * Fires when field is cleared with {@link #function-clear} method
   * @event clear
   */
  /**
   * Wrapper button config object. See {@link @bryntum/core-thin/lib/widget/Button} for list of available configs.
   * @config {ButtonConfig}
   */
  buttonConfig: null,
  /**
   * Underlying field config object. See {@link @bryntum/core-thin/lib/widget/FileField} for list of available configs.
   * @config {FileFieldConfig}
   */
  fileFieldConfig: null,
  /**
   * Set to `false` to hide the badge indicating the number of files selected
   * @prp {Boolean}
   * @default true
   */
  showBadge: true
});
FilePicker.initClass();
FilePicker._$name = "FilePicker";
export {
  FilePicker as default
};
